
import * as z from 'zod';

export const applicationSchema = z.object({
  firstName: z.string().min(2, 'Le prénom doit contenir au moins 2 caractères'),
  lastName: z.string().min(2, 'Le nom doit contenir au moins 2 caractères'),
  email: z.string().email('Email invalide'),
  phone: z.string().min(10, 'Numéro de téléphone invalide'),
  jobPosition: z.string().min(1, 'Veuillez sélectionner un poste'),
  experience: z.string().min(1, 'Veuillez sélectionner votre niveau d\'expérience'),
  motivation: z.string().min(50, 'Votre lettre de motivation doit contenir au moins 50 caractères'),
});

export type ApplicationFormData = z.infer<typeof applicationSchema>;

export const jobPositions = [
  "Candidature spontanée",
  "Conducteur de benne",
  "Technicien de maintenance", 
  "Commercial terrain",
  "Agent de tri",
  "Responsable d'exploitation",
  "Comptable",
  "Assistant administratif"
];

export const experienceLevels = [
  "Débutant (0-1 an)",
  "Junior (1-3 ans)",
  "Confirmé (3-7 ans)",
  "Senior (7+ ans)"
];
